import React from 'react';
import Dashboard from '../Dashboard/Dashboard';

const Content = ({children}) => (
    <main >
        {children || <Dashboard />}
    </main>
);

export default Content;
